var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "margin-y-3 margin-x-10" },
    [
      _c(
        "h1",
        {
          staticClass: "margin-t-4 margin-b-10",
          staticStyle: {
            "text-transform": "uppercase",
            "font-weight": "700",
            "letter-spacing": "1px",
            "font-size": "30px",
          },
        },
        [_vm._v("Campaign - " + _vm._s(_vm.campaign_name))]
      ),
      _vm._v(" "),
      _c("campaign-form", {
        ref: "campaignForm",
        attrs: { campaign: _vm.campaign },
        scopedSlots: _vm._u([
          {
            key: "action-buttons",
            fn: function () {
              return [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary btn-md",
                    attrs: {
                      click: () => {
                        return _vm.updateCampaign(false)
                      },
                    },
                  },
                  [_vm._v("Save")]
                ),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-md",
                    attrs: {
                      click: () => {
                        return _vm.updateCampaign(true)
                      },
                    },
                  },
                  [_vm._v("Save & view campaigns")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "h2",
        { staticClass: "flex justify-between align-center margin-t-10" },
        [
          _vm._v("Requests"),
          _c(
            "router-link",
            {
              staticStyle: { "font-size": "14px" },
              attrs: {
                to: {
                  name: "requests.create",
                  query: { campaign_id: _vm.campaign.id },
                },
              },
            },
            [_c("i", { staticClass: "fa fa-plus" }), _vm._v("  Create Request")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "list-style-type": "none" } },
        [
          _vm._l(_vm.bookings, function (booking) {
            return _c(
              "div",
              { key: booking.id },
              [
                booking.type === "vetting"
                  ? _c("vetting-list-item", { attrs: { booking: booking } })
                  : _vm._e(),
                _vm._v(" "),
                booking.type === "request"
                  ? _c("request-list-item", { attrs: { booking: booking } })
                  : _vm._e(),
                _vm._v(" "),
                booking.type === "booking"
                  ? _c("booking-list-item", { attrs: { booking: booking } })
                  : _vm._e(),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "lazy-loading",
            {
              ref: "lazyLoading",
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading,
                "reached-bottom": _vm.getNextCampaignBookings,
              },
            },
            [
              _c("pickstar-loading", {
                attrs: { slot: "loading" },
                slot: "loading",
              }),
              _vm._v(" "),
              _c("span", { attrs: { slot: "finished" }, slot: "finished" }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }